<template>
  <div v-click-outside="close" class="switchLangWrapper" @click="toggle">
    <span class="lang">{{ $t(`langs.${lang}`) }}</span>
    <div class="navborder" />
    <transition name="fade">
      <div v-if="display" class="contextMenu">
        <div
          v-for="lang in availableLangs"
          :key="lang"
          class="select"
          @click="switchLang(lang)"
        >
          <span class="text">{{ $t(`langs.${lang}`) }}</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex"
import patch_lang from "~/mixins/band/patch_lang"
import events_mixin from "~/mixins/events"

export default {
  mixins: [patch_lang, events_mixin],
  data: function () {
    return {
      display: false,
    }
  },
  computed: {
    ...mapGetters({ is_logged_in: "user/IS_LOGGED_IN" }),
    ...mapState({
      availableLangs: (state) => state.locales,
      lang: (state) => state.locale,
      userEmail: (state) => state.user.email,
    }),
  },
  methods: {
    close: function () {
      this.display = false
    },
    toggle: function () {
      this.display = !this.display
    },
    switchLang: function (target_lang) {
      this.trackEvent({
        category: "i18n",
        action: "Toggle",
        target_lang: target_lang,
        origin_lang: this.lang,
      })
      if (this.is_logged_in) this.patchLang(target_lang, this.userEmail)
      else this.updateLang(target_lang)
    },
  },
}
</script>

<style scoped>
.switchLangWrapper {
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
}

.toggle {
  position: absolute;
  width: 100%;
  top: 0px;
  z-index: 1;
}

.switchLangWrapper:hover .navborder {
  opacity: 1;
}

.lang {
  font-size: var(--font-size-big);
  color: var(--color-black);
  cursor: pointer;
}

.langSwitch {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  cursor: pointer;
  margin-right: 32px;
  height: 100%;
  right: 0px;
  transition: 0.15s var(--trans-standart);
}

.langSwitch .navborder {
  opacity: 0;
  width: 100%;
  height: 6px;
  border-radius: 24px;
  bottom: 0px;
  left: 0px;
  background-color: var(--color-main);
  transition: 0.3s;
  position: absolute;
}

.contextMenu {
  top: 100%;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  position: absolute;
  background-color: var(--color-white);
  box-shadow: var(--shadow-sticky-bottom);
  border-radius: 2px;
  z-index: 10;
}

.select {
  display: flex;
  align-items: center;
  height: 40px;
  width: 186px;
  background-color: var(--color-white);
  cursor: pointer;
}

.select:hover {
  background-color: var(--color-main-dull);
  color: var(--color-main);
}

.text {
  margin-left: 16px;
}
</style>
